import React from 'react'
import { BaseWidget } from '../BaseWidget'
import { Typography } from 'components'
import { useTranslation } from 'utils/useTranslation'
import styled from 'styled-components'
import { padding } from '@evrekadev/evreka-ui-components'
import illustration from 'assets/png/illustrations.png'
import { selectCurrentUser } from 'services/slices/auth'
import { useSelector } from 'react-redux'

export type WelcomeWidgetProps = {}

export const WelcomeWidget: React.FC<WelcomeWidgetProps> = () => {
  const { t } = useTranslation('pages.home')
  const user = useSelector(selectCurrentUser)

  return (
    <BaseWidget size="1x2">
      <Illustration src={illustration} />
      <Gradient />
      <WelcomeWidgetStyled>
        <Typography fontSize="header_xs" fontWeight="semibold">
          {user && t('welcome_back', { id: user.username })}
        </Typography>
        <Typography fontSize="text_md" color="grey500">
          {t('have_a_zero_waste_day')}
        </Typography>
      </WelcomeWidgetStyled>
    </BaseWidget>
  )
}

const WelcomeWidgetStyled = styled.div`
  ${padding([8])}
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: end;
  p {
    margin: 0;
  }
  z-index: 2;
  position: relative;
`
const Illustration = styled.img`
  position: absolute;
  bottom: 0;
  right: 0;
  height: 100%;
  z-index: 1;
`

const Gradient = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  height: 100%;
  width: 100%;
  z-index: 2;
  background: linear-gradient(270deg, rgba(255, 255, 255, 0) 0%, #ffffff 75%);
`
